import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatDialogRef } from '@angular/material/dialog';
import { TechSupportComponent } from './tech-support.component';


@NgModule({
  declarations: [
    TechSupportComponent,
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    }
  ]
})
export class TechSupportModule { }